import React, { useEffect, useState, useRef } from 'react';
import { Grid, Box, Typography, FormControlLabel } from "@mui/material";
import { AntSwitch } from 'common/AntSwitch';
import ScreenGroup from "./ScreenGroup";

interface PermissionObject {
  masterPermissionId: Number
  applicationName: string
  screenName: string
  moduleName: string
  permissionStatus: string
  addPermission: boolean
  editPermission: boolean
  deletePermission: boolean
}

interface SwitchGroupProps {
  roleData: string,
  switchChange: Function,
  pageChange: Function,
  updateModule: Function,
  data: Array<PermissionObject>,
  isEdit?: boolean
}




const SwitchGroup: React.FC<SwitchGroupProps> = ({ roleData, switchChange, data, pageChange, updateModule, isEdit }) => {
  const [checked, setChecked] = useState(false);
  const [filtered, setFiltered] = useState<any>([]);

  useEffect(() => {
    if (data.length > 0) {
      let f = data.filter((d: any) => d.moduleName === roleData);
      setFiltered(f);
    }
  }, [data, roleData]);

  // checks if any pages can add or can edit so that it checks the module
  useEffect(() => {
    if(isEdit && filtered.length > 0) {
      for(let i = 0; i < filtered.length; i++) {
        if(filtered[i].canEdit || filtered[i].canAdd) {
          setChecked(true);
        }
      }
    }
  }, [isEdit, filtered]);

  // useEffect(() => {
  //   if(filtered.length > 0) {
  //     let allCheck = false;
  //     for(let i = 0; i < filtered.length; i++) {
  //       if(filtered[i].canAdd || filtered[i].canEdit) {
  //         allCheck = true;
  //       }
  //     }
  //     setChecked(allCheck);
  //   }
  // }, [filtered]);

  

  const handleUpdateModule = (val: boolean) => {
    setChecked(val);
    updateModule(roleData, val);
  }

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* <FormControlLabel
          label=""
          control={<AntSwitch sx={{ m: 1, marginRight: 0 }} checked={checked} onChange={(e: any) => handleUpdateModule(e.target.checked)} />}
        /> */}
        <Typography sx={{ fontSize: ".8rem", fontWeight: "bold" }}>{roleData}</Typography>
      </Box>

      <Box sx={{ paddingLeft: "2.6rem" }}>
        {filtered.map((f: any, i: number) =>
          <ScreenGroup key={i} roleData={f} switchChange={switchChange} parentChecked={checked} pageChange={pageChange} isEdit={isEdit}/>
        )}
      </Box>
    </Box>
  )
}

export default SwitchGroup;